import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import Icon from 'Icons/NavigationItem/Company';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyOnboardingFlowPage = React.lazy(() => import('./Pages'));

const onboardingFlowConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:company.onboarding.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.company.onboarding.title',
            url: '/welcome-settings',
            Icon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyOnboardingFlowPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default onboardingFlowConfiguration;
